import React, { useState } from 'react';
import ResultTab, { ResultMenuType } from '@components/phs/pacc/results/result/resultTab';
import ApplyResult from '@components/phs/pacc/results/result/applyResult';
import CompetencyResult from '@components/phs/pacc/results/result/competencyResult';
import { PHSAnalysisType } from '@domain/constant/phsAnalysisType';
import classnames from 'classnames/bind';
import styles from './paccResult.module.scss';

const cx = classnames.bind(styles);

// 내 프로필 > 개발자 검사 결과 > 개발자 역량검사
interface PaccResultProps {
  sn: number;
  resultState: PHSAnalysisType | null;
  isCompetency?: boolean;
}

const PaccResult = ({ sn, resultState, isCompetency }: PaccResultProps) => {
  const [resultMenu, setResultMenu] = useState<ResultMenuType>('APPLY');

  const getResult = () => {
    switch (resultMenu) {
      // 응시 분석 결과
      case 'APPLY':
        return <ApplyResult sn={sn} resultState={resultState} />;

      // 역량 분석 결과
      case 'COMPETENCY':
        return <CompetencyResult sn={sn} />;

      default:
        return null;
    }
  };

  if (!sn) return null;

  return (
    <div className={cx('resultArea')}>
      <ResultTab
        resultState={resultState}
        resultMenu={resultMenu}
        setResultMenu={setResultMenu}
        isCompetency={isCompetency}
      />

      {getResult()}
    </div>
  );
};

export default PaccResult;
